import { render, staticRenderFns } from "./PcodeCard.vue?vue&type=template&id=070a2501&"
import script from "./PcodeCard.vue?vue&type=script&lang=js&"
export * from "./PcodeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports